import Vue from 'vue'
import Vuex from 'vuex'

// 让vue使用vuex工具来实现组件之间的数据共享
Vue.use(Vuex)

const state = {
  loginState: false,
  noticeMessage:"",
  active: "sy"
}
const store = new Vuex.Store({
  state
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js